module.exports = __webpack_public_path__ + "static/media/resume.529ccffd.pdf";